import { useEffect } from 'react';
import { GoFormzAgentContextTypes, GoFormzAgentLocalState, GoFormzAgentTemplateContext } from './goFormz-agent-types';
import { useImmerState } from '../hooks/useImmerState';
import { useGoFormzAgentContext } from './GoFormzAgentProvider';

const DEFAULT_STATE: GoFormzAgentLocalState = {
  loading: false,
  isDirty: false,
  [GoFormzAgentContextTypes.Template]: {
    templateId: '',
    selectedFieldIds: [],
    selectedProperty: '',
    selectedCalculation: '',
    suggestedCalculationSelected: ''
  },
  [GoFormzAgentContextTypes.Workflow]: {},
  [GoFormzAgentContextTypes.Datasource]: {},
  [GoFormzAgentContextTypes.Form]: {},
  errorMessage: null
};

export interface GoFormzAgentHook {
  loading: boolean;
  templateContext: GoFormzAgentTemplateContext;
  workflowContext: any;
  datasourceContext: any;
  formContext: any;
  errorMessage: string | null;
  setTemplateContext: (context: GoFormzAgentTemplateContext) => Promise<number>;
  openAgent: () => void;
  closeAgent: () => void;
  isAgentOpen: boolean;
  selectFormula: (formula: string) => void;
  selectedFormula: string;
  goPilotEnabled: boolean;
}

export function useGoFormzAgent({ showErrorMessage = true } = {}): GoFormzAgentHook {
  // Get state from context provider
  const {
    isAgentOpen,
    selectedFormula,
    templateContext: sharedTemplateContext,
    goPilotEnabled,
    openAgent,
    closeAgent,
    selectFormula,
    setTemplateContext
  } = useGoFormzAgentContext();

  const [state] = useImmerState(DEFAULT_STATE);
  const { loading, workflowContext, datasourceContext, formContext, errorMessage } = state;

  // Show error messages if enabled
  useEffect(() => {
    if (showErrorMessage && errorMessage) {
      console.error(errorMessage);
    }
  }, [showErrorMessage, errorMessage]);

  // Return the same interface as before, but now powered by the context
  return {
    loading,
    templateContext: sharedTemplateContext,
    workflowContext,
    datasourceContext,
    formContext,
    errorMessage,
    setTemplateContext,
    closeAgent,
    isAgentOpen,
    openAgent,
    selectFormula,
    selectedFormula,
    goPilotEnabled
  };
}
